import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";
import { throwIfRequestError } from "../../hooks/request-error";

// usePartners — GET /api/partner/admin, the source of the B2B tab's vendor chips.
//
// The prototype hardcodes five vendor names (Visit, ACKO, GLP1, Nutrapack, Tatva
// Practise). Checked against the database, that list is demo fiction: Nutrapack has no
// partner row and zero orders, GLP1 has no partner row, and only Visit and ACKO are
// genuinely `channel=B2B`. Meanwhile fourteen real partners have orders — including
// Dr. Rajul Aggarwal with 474 — none of which those five chips would show.
//
// So the chips come from here instead. A partner added to the table appears as a chip
// with no deploy, and a chip can never name a vendor that does not exist.

export default function usePartners() {
    return useQuery(
        ["ops-partners"],
        async () => {
            const result = await request({ url: "/partner/admin", method: "GET", params: { size: 200 } });
            throwIfRequestError(result);
            const body = result.data;
            if (!body?.success) throw body;

            const rows = body.data?.rows || [];
            return rows
                .filter((partner) => partner.status === "ACTIVE")
                .map((partner) => ({ id: String(partner.id), name: partner.name, type: partner.type }));
        },
        // Partners change on a business-development cadence, not a per-click one.
        { staleTime: 300000, retry: false }
    );
}
